export default {"src":"/_next/static/media/help-center.2c83f8da.svg","height":14,"width":14};